import { range } from 'lodash';
import { selectMember, selectSubscription } from 'logic/member';
import {
  fetchReviews,
  fetchReplies,
  likeReview,
  createReview,
  selectReviews,
  selectReviewsPagination,
  selectReviewsPages,
  selectReplies,
} from 'logic/reviews';

export const Reviews = {
  bindings: {
    formTop: '<',
    reviewableId: '<',
    reviewableType: '@',
    wordingPlural: '@',
    wordingRating: '@',
    wordingSingular: '@',
    onCancel: '&',
  },

  template: `
    <section class="reviews">
      <div class="d-flex flex-column" ng-hide="$ctrl.isLoading">
        <div ng-class="{ 'order-1 mb-4': !$ctrl.formTop, 'order-2': $ctrl.formTop }"
          ng-show="$ctrl.reviews">
          <header class="reviews-header">
            <h4>{{ $ctrl.wordingPlural }}</h4>
          </header>
          <div ng-repeat="page in $ctrl.pageRange() track by $index">
            <review
              review="$ctrl.reviews[reviewId]"
              replies="$ctrl.replies"
              member-id="$ctrl.member.id"
              on-like="$ctrl.onLike(reviewId)"
              on-submit="$ctrl.onSubmit(data, parentId)"
              on-show-replies="$ctrl.onShowReplies(parentId)"
              ng-repeat="reviewId in $ctrl.pages[page] track by $index">
            </review>
          </div>
          <div ng-hide="$ctrl.pagination">
            No <span class="text-lowercase">{{ $ctrl.wordingPlural }}</span> yet.
            Add one own below.
          </div>
          <hr>
          <div class="mt-4 ml-4" ng-show="$ctrl.pagination.totalPages > 1 && !$ctrl.pagination.lastPage">
            <button class="btn btn-pill theme-btn ml-4"
              type="button"
              ng-click="$ctrl.loadMore()">
              Load more
            </button>
          </div>
        </div>
        <div ng-class="{ 'order-1 mb-4': $ctrl.formTop, 'order-2': !$ctrl.formTop }">
          <form-review
            wording-rating="{{ $ctrl.wordingRating }}"
            wording-singular="{{ $ctrl.wordingSingular }}"
            on-submit="$ctrl.onSubmit(data)"
            on-cancel="$ctrl.onCancel()">
          </form-review>
        </div>
      </div>
    </section>`,

  controller($ngRedux, $element, $state) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(
          this.mapState.bind(this),
          this.mapDispatch()
        );

        this.unsubscribe = connect(this);
        this.page = 1;

        this.fetchReviews(
          this.member.id,
          this.voomeProductId,
          this.reviewableId,
          this.reviewableType
        );
      },

      $onDestroy() {
        this.unsubscribe();
      },

      onLike(reviewId) {
        this.likeReview(this.member.id, reviewId, this.voomeProductId);
      },

      onSubmit({ review, rating }, parentId) {
        const params = {
          reviewableId: this.reviewableId,
          reviewableType: this.reviewableType,
          review,
          rating,
          parentId,
        };

        this.createReview(this.member.id, this.voomeProductId, params);
        this.scrollToTop();
      },

      onShowReplies(parentId) {
        this.fetchReplies(
          this.member.id,
          this.voomeProductId,
          this.reviewableId,
          this.reviewableType,
          parentId
        );
      },

      loadMore() {
        this.page = this.page + 1;
        this.fetchReviews(
          this.member.id,
          this.voomeProductId,
          this.reviewableId,
          this.reviewableType,
          this.page
        );
      },

      pageRange() {
        if (this.pagination) {
          return range(1, this.pagination.page + 1);
        } else {
          return [];
        }
      },

      scrollToTop() {
        $('html, body').animate({
          scrollTop: $($element).offset().top,
        });
      },

      mapState({ member, reviews }) {
        const params = {
          id: this.reviewableId,
          type: this.reviewableType,
        };

        return {
          isLoading: reviews.isLoading,
          member: selectMember(member),
          pages: selectReviewsPages(reviews, params),
          pagination: selectReviewsPagination(reviews, params),
          replies: selectReplies(reviews),
          reviews: selectReviews(reviews),
          voomeProductId: selectSubscription(member).voomeProductId,
        };
      },

      mapDispatch() {
        return {
          fetchReviews,
          fetchReplies,
          createReview,
          likeReview,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Reviews.js